import type { JSX } from '@builder.io/qwik';
import { component$, useSignal, useVisibleTask$ } from '@builder.io/qwik';
import type { TwitterBlockAttsInterface } from '~/types/AppData/Blocks/TwitterBlockInterface';
import { cva } from 'class-variance-authority';
import { useIsPremiumTemplate } from '~/utilities/useIsPremiumTemplate';

const cssClasses = cva('', {
  variants: {
    isPremium: {
      true: 'flex justify-center',
    },
  },
});

export default component$(
  ({ html }: TwitterBlockAttsInterface): JSX.Element => {
    const outputRef = useSignal<Element>();

    const isPremium = useIsPremiumTemplate();

    // This uses an intersection observer on the client side to update the signal and load the iframe
    // when it is scrolled into view
    // Throws a linter warning because it can be misused, but this is a good use case for it
    // eslint-disable-next-line qwik/no-use-visible-task
    useVisibleTask$(() => {
      if (!window.mmTwitterLoaded) {
        window.mmTwitterLoaded = true;

        const script = document.createElement('script');
        script.async = true;
        script.innerHTML = `window.twttr = (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);
    
      t._e = [];
      t.ready = function(f) {
        t._e.push(f);
      };
    
      return t;
    }(document, "script", "twitter-wjs"));`;
        document.body.appendChild(script);
      }

      if (window.twttr) {
        setTimeout(() => {
          window.twttr.widgets.load(outputRef.value);
        }, 500);
      }
    });

    return (
      <figure
        class={cssClasses({ isPremium })}
        ref={outputRef}
        dangerouslySetInnerHTML={html}
      />
    );
  }
);
